module.exports = __webpack_public_path__ + "static/media/MP3.655fd0c9.svg";